import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import Clipper from '@components/Clipper';
import Article from '@components/pages/Article';

registerWithErrorBoundary({
  Article,
  Clipper,
});
